import React from 'react';
import {
  Box,
  List,
  ListItem,
  ListItemText,
  Paper,
  Typography,
} from '@mui/material';
import { useTranslation } from '../../../app/LanguageContext';
import { formatCurrency } from '../../../app/currency';
import VariableCostsEditor from '../../../extensions/price-simulator-3d/VariableCostsEditor';

export default function ProductVariableCostsSection({
  inheritedRows = [],
  rows = [],
  onChange,
  disabled = false,
}) {
  const { translate } = useTranslation();

  return (
    <Paper sx={{ p: 2, mb: 2 }}>
      <Typography variant="h6" component="h2" gutterBottom>
        {translate('products.variable_cost_defaults_title')}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        {translate('products.variable_cost_defaults_hint')}
      </Typography>

      {inheritedRows.length > 0 && (
        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle2" gutterBottom>
            {translate('products.variable_cost_inherited_title')}
          </Typography>
          <List dense disablePadding sx={{ bgcolor: 'action.hover', borderRadius: 1, px: 1 }}>
            {inheritedRows.map((row) => (
              <ListItem key={row.id} disableGutters sx={{ py: 0.5 }}>
                <ListItemText
                  primary={row.name || '—'}
                  secondary={formatCurrency(row.cost_unit ?? 0)}
                />
              </ListItem>
            ))}
          </List>
        </Box>
      )}

      <Typography variant="subtitle2" gutterBottom>
        {translate('products.variable_cost_direct_title')}
      </Typography>
      <VariableCostsEditor
        rows={rows}
        onChange={onChange}
        disabled={disabled}
        showSectionTitle={false}
      />
    </Paper>
  );
}
